var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.typeClass},[_vm._v("\n  "+_vm._s(_vm.transaction.amount >= 0 ? "+" : "")+"\n  "+_vm._s(_vm._f("priceDisplay")(_vm.transaction.amount))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }